import * as t from 'io-ts';

export const RatingTypeSchema = t.keyof({
    P: null,
    A: null,
});

export type RatingType = t.TypeOf<typeof RatingTypeSchema>;
